(function(){
  function init(){
    document.querySelectorAll('[data-zabdi-coco-gallery]').forEach(function(gallery){
      if(gallery.dataset.zabdiCocoReady==='1')return;
      gallery.dataset.zabdiCocoReady='1';
      var main=gallery.querySelector('[data-zabdi-coco-featured]');
      var thumbs=gallery.querySelectorAll('[data-zabdi-coco-thumbnail]');
      thumbs.forEach(function(btn){
        btn.addEventListener('click',function(){
          if(!main)return;
          main.src=btn.getAttribute('data-full');
          main.alt=btn.getAttribute('data-alt')||'Imagen Coco Zabdi';
          main.classList.toggle('is-packshot',btn.getAttribute('data-kind')==='packshot');
          thumbs.forEach(function(t){t.classList.remove('is-selected');t.setAttribute('aria-pressed','false');});
          btn.classList.add('is-selected');btn.setAttribute('aria-pressed','true');
        });
      });
    });
    var nutritionModal=document.getElementById('zabdi-coco-nutrition-dialog');
    document.querySelectorAll('[data-zabdi-coco-open-nutrition]').forEach(function(trigger){
      if(trigger.dataset.zabdiCocoNutritionReady==='1')return;
      trigger.dataset.zabdiCocoNutritionReady='1';
      trigger.addEventListener('click',function(){
        if(!nutritionModal)return;
        if(typeof nutritionModal.showModal==='function')nutritionModal.showModal();
        else {nutritionModal.setAttribute('open','');nutritionModal.focus();}
      });
    });
    if(nutritionModal && nutritionModal.dataset.zabdiCocoReady!=='1'){
      nutritionModal.dataset.zabdiCocoReady='1';
      nutritionModal.querySelectorAll('[data-zabdi-coco-close-nutrition]').forEach(function(btn){
        btn.addEventListener('click',function(){nutritionModal.close?nutritionModal.close():nutritionModal.removeAttribute('open');});
      });
      nutritionModal.addEventListener('click',function(e){if(e.target===nutritionModal&&nutritionModal.close)nutritionModal.close();});
    }
    var sticky=document.querySelector('[data-zabdi-coco-sticky-cart]');
    var realBuy=document.querySelector('.zabdi-coco-product .product-form__submit');
    var stickyBuy=sticky&&sticky.querySelector('[data-zabdi-coco-sticky-buy]');
    if(sticky&&realBuy&&stickyBuy&&sticky.dataset.zabdiCocoStickyReady!=='1'){
      sticky.dataset.zabdiCocoStickyReady='1';
      stickyBuy.addEventListener('click',function(){if(!realBuy.disabled)realBuy.click();});
      var observed=realBuy.closest('.product-form__buttons')||realBuy;
      if('IntersectionObserver' in window){
        var obs=new IntersectionObserver(function(entries){entries.forEach(function(entry){sticky.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.bottom<0);});},{threshold:.06});
        obs.observe(observed);
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();